import type * as Api from '@ViewModels';
import { getDisplayName } from '../../../models/NameUtils';

/**
 * Display label for the lead(s) a coaching call was with. Leads with the first contact that has a
 * resolvable name (per `getDisplayName`, which falls back to primary email) and appends a `+N`
 * count of the remaining contacts so a multi-contact call stays scannable in one line. Returns an
 * empty string when there are no contacts with a resolvable name.
 */
export const getLeadLabel = (contacts: Api.IContact[] | null | undefined): string => {
	if (!contacts || contacts.length === 0) {
		return '';
	}

	const primary = contacts.map(contact => getDisplayName(contact)).find(Boolean);
	if (!primary) {
		return '';
	}

	const othersCount = contacts.length - 1;
	return othersCount > 0 ? `${primary} +${othersCount}` : primary;
};

/** What a coaching call is "about" wherever one is named on its own — a card row, an alert. */
export const getCallSubject = (view: { company?: { companyName?: string }; contacts?: Api.IContact[] }): string =>
	getLeadLabel(view.contacts) || view.company?.companyName?.trim() || 'Coaching call';
